import React, { useState, useEffect } from "react";
import Header from "../FleetHeader/Header";
import CarouselSection from '../CarouselSection/CarouselSection';
import { cars } from '../../services/api';
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const MotoFleet = () => {
  const [filters, setFilters] = useState({
    motoQuads: []
  });

  const [motoData, setMotoData] = useState({
    motoQuads: []
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await cars.getAll();
        const today = new Date();
        
        // Get today's date for availability check
        const todayStr = today.toISOString();
        
        // Fetch current price for all cars in one request
        const availabilityResponse = await cars.getAvailable({
          startDate: todayStr,
          endDate: todayStr,
          includeAll: true
        });
        
        // Create a map of car IDs to dynamic prices
        const dynamicPriceMap = {};
        availabilityResponse.data.forEach(car => {
          dynamicPriceMap[car._id] = car.dynamicPrice;
        });
        
        // Filter cars to only show active/available ones
        const activeCars = response.data.filter(car => 
          car.status === 'available' || car.status === 'rented' || !car.status // Include cars without status field for backward compatibility
        );
        
        const allCars = activeCars.map(car => ({
          ...car,
          name: `${car.make} ${car.model} ${car.engineCapacity || ''} ${car.transmission.charAt(0).toUpperCase() + car.transmission.slice(1)} (or Similar)`.trim(),
          image: car.images[0],
          dynamicPrice: dynamicPriceMap[car._id] || car.basePrice // Use dynamic price if available, otherwise use base price
        }));
        
        // Group vehicles by category
        const grouped = {
          motoQuads: [
            ...allCars.filter(car => car.category === 'ATV-Quads'),
            ...allCars.filter(car => car.category === 'Motorbikes')
          ]
        };

        setMotoData(grouped);
      } catch (err) {
        console.error('Error fetching vehicles:', err);
        setError('Failed to load vehicles. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchCars();
  }, []);

  const filterCars = (cars, selectedFilters) => {
    if (!selectedFilters || selectedFilters.length === 0) return cars;

    return cars.filter(car => {
      return selectedFilters.every(filter => {
        if (filter.label.includes('Person')) {
          return car.persons === filter.value;
        }
        if (filter.label.includes('Suitcase')) {
          return car.suitcases === filter.value;
        }
        return true;
      });
    });
  };

  const sliderRefs = {
    motoQuads: React.useRef()
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="text-center text-red-500 py-8">{error}</div>;
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-[1440px] mx-auto px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl mb-4 Aleo">
            Explore Our Selection for <b>Moto</b> and <b>Quad</b> Fans
          </h2>
          <hr className="w-40 border-2 border-red-400 mx-auto mb-4" />
          <p className="text-gray-400 text-sm max-w-2xl mx-auto Aleo">
            Choose your ride, embrace the freedom, and let the excitement begin as you explore <b>Mykonos</b> like never before.
          </p>
        </div>

        <div className="mb-12">
          <Header 
            title="Motorbikes - ATV-Quads"
            link="/moto-quads"
            onNext={() => sliderRefs.motoQuads.current.slickNext()}
            onPrev={() => sliderRefs.motoQuads.current.slickPrev()}
            cars={motoData.motoQuads}
            onFilterChange={(selected) => setFilters(prev => ({ ...prev, motoQuads: selected }))}
          />
          <CarouselSection 
            cars={filterCars(motoData.motoQuads, filters.motoQuads)}
            sliderRef={sliderRefs.motoQuads}
          />
        </div>
      </div>
    </section>
  );
};

export default MotoFleet;
